import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const LegalContactPerson = ({ data }) => {
  return (
    <DescriptionList stripEmpty={true} data={data} disableGutters={true}>
      <DescriptionItem
        label={'Name'}
        value={`${data?.legalContact?.firstName} ${data?.legalContact?.lastName}`}
      />
      <DescriptionItem label={'Email'} field={'legalContact.email'} />
      <DescriptionItem label={'Phone'} field={'legalContact.phone'} />
      <DescriptionItem label={'Skype'} field={'legalContact.imAddress'} />
    </DescriptionList>
  );
};

export default LegalContactPerson;
